import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends BaseService {

  getCountryCode(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('admin/countryTelCode')).pipe(
      map((res: any) => {
        return res.data;
      })
    );
  }
}